// extracted by mini-css-extract-plugin
export default {"container":"AppInfoData_container__tv2xB"};